// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__1IRiH","Tagline":"Banner_Tagline__3nHEQ","Subline":"Banner_Subline__isxjm"};